import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';

import styles from './PanelHeader.module.scss';
import usePresenter from './PanelHeader.presenter';
import getProps from './PanelHeader.props';
import { PanelHeaderCombinedProps } from './types';

const PanelHeader: React.FC<PanelHeaderCombinedProps> = (props) => {
  const {
    state,
    type,
    className,
    classes,
    divider,
    button,
    text,
    button1,
  } = usePresenter(props);

  const variantName = `${state}${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`panelHeader${variantName}`];

  let componentView;

  switch (variantName) {
    case 'CollapsedDefault':
    case 'ExpandedDefault': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Divider
            className={cx(styles.divider, classes?.divider)}
            {...internalProps.divider}
            {...divider}/>
          <div className={cx(styles.headerContent, classes?.headerContent)}>
            <Button
              className={cx(styles.button, classes?.button)}
              {...internalProps.button}
              {...button}/>
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text}/>
          </div>
        </div>
      );
      break;
    }
    case 'CollapsedExpandable':
    case 'ExpandedExpandable': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Divider
            className={cx(styles.divider, classes?.divider)}
            {...internalProps.divider}
            {...divider}/>
          <div className={cx(styles.headerContent, classes?.headerContent)}>
            <div className={cx(styles.leftContent, classes?.leftContent)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
              <Text
                className={cx(styles.text, classes?.text)}
                {...internalProps.text}
                {...text}/>
            </div>
            <Button
              className={cx(styles.button1, classes?.button1)}
              {...internalProps.button1}
              {...button1}/>
          </div>
        </div>
      );
      break;
    }
    case 'DefaultTextOnly': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Divider
            className={cx(styles.divider, classes?.divider)}
            {...internalProps.divider}
            {...divider}/>
          <div className={cx(styles.headerContent, classes?.headerContent)}>
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text}/>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default PanelHeader;
